import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.slice.js";
import "regenerator-runtime/runtime.js";
import * as echarts from "echarts";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, onMounted, reactive, ref, onUnmounted } from "vue";
import { useStore } from "vuex";
import staticData from "@/assets/data/dataScreen.json";
export default defineComponent({
  name: "PartyPayIndex",
  components: {},
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var total = ref(0);
    var store = useStore();
    var Data = reactive({
      option: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999"
            }
          }
        },
        legend: {
          data: ["本月总额", "总数"],
          top: "0%",
          textStyle: {
            color: "#4dbdff"
          }
        },
        xAxis: [{
          type: "category",
          data: ["1月", "", "3月", "", "5月", "", "7月", "", "9月", "", "11月", ""],
          axisPointer: {
            type: "shadow"
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#4dbdff"
            }
          }
        }],
        yAxis: [{
          type: "value",
          name: "元/月",
          nameTextStyle: {
            color: "#4dbdff",
            padding: [0, 40, 0, 0]
          },
          min: 0,
          // max:6000,
          // interval: 500,
          axisLabel: {
            formatter: "{value}",
            textStyle: {
              color: "#4dbdff"
            }
          },
          splitLine: {
            show: false
          }
        }],
        series: [{
          name: "本月总额",
          type: "bar",
          barWidth: 20,
          itemStyle: {
            normal: {
              barBorderRadius: 4,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 1,
                color: "#3ad9cb"
              }, {
                offset: 0,
                color: "#00c0fe"
              }])
            }
          },
          data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 250, 32.6, 20.0, 6.4, 3.3]
        }]
      }
    });
    onMounted(function () {
      if (store.state.system.demonstration) {
        Data.option.series[0].data = staticData.thoughtData;
        total.value = 3475.9;
        getMountEcherts();
      } else {
        getList();
        taskGetPartyPay();
      }
    });

    var getList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getPartyPaymentDataScreen();

              case 2:
                _context.next = 4;
                return getMountEcherts();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getList() {
        return _ref.apply(this, arguments);
      };
    }();

    var timer;

    var taskGetPartyPay = function taskGetPartyPay() {
      timer = setInterval(function () {
        getList(); // clearInterval(timer);
        // taskGetPartyPay();
      }, 10000);
    };

    onUnmounted(function () {
      clearInterval(timer);
    }); // 党费缴纳

    var getPartyPaymentDataScreen = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getPartyPaymentDataScreen"]();

              case 2:
                res = _context2.sent;

                if (res.code == 0) {
                  Data.option.series[0].data = res.data.slice(0, 11);
                  total.value = res.data[12];
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getPartyPaymentDataScreen() {
        return _ref2.apply(this, arguments);
      };
    }(); //挂载eCharts


    var myChartRef = ref();
    var myChart;

    var getMountEcherts = function getMountEcherts() {
      myChartRef.value = document.getElementById("partyPaymentMain");

      if (myChartRef.value) {
        myChart = echarts.init(myChartRef.value);
        myChart.setOption(Data.option);
      }
    };

    var initpartyPaymentpay = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                myChart.resize();

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function initpartyPaymentpay() {
        return _ref3.apply(this, arguments);
      };
    }();

    window.addEventListener('resize', function () {
      myChart.resize();
    });
    return {
      Data: Data,
      total: total,
      initpartyPaymentpay: initpartyPaymentpay,
      getMountEcherts: getMountEcherts,
      getList: getList,
      getPartyPaymentDataScreen: getPartyPaymentDataScreen
    };
  }
});